<script setup>
import { ref } from "vue";
import GameCard from "../layout/GameCard.vue";
import Sidebar from "../layout/Sidebar.vue";
import GameDetailPopup from "../layout/GameDetailPopup.vue";

const games = ref([]);

const showInfoGame = ref(false);
const selectedGame = ref(null);

function onCategorySelected(payload) {
  if (payload.error) {
    console.error(payload.error);
    games.value = [];
    return;
  }
  games.value = payload.games || [];
}

function openGameDetail(game) {
  selectedGame.value = game;
  showInfoGame.value = true;
}
</script>

<template>
  <div class="page-wrap">
    <Sidebar @category-selected="onCategorySelected" />

    <main class="content">
      <div class="section-title">Recommended</div>

      <div v-if="!games.length">No games to display. Select a category.</div>

      <div class="game-grid">
        <GameCard
          v-for="g in games"
          :key="g.id || g.title"
          :title="g.title"
          :img="g.thumbnail"
          :video="g.preview_video"
          :label="g.label || null"
          :game="g"
		  @view-detail="openGameDetail"
        />
      </div>
    </main>
	
	<GameDetailPopup
	  :show="showInfoGame"
	  :game="selectedGame"
	  @close="showInfoGame = false"
	/>
  </div>
</template>

<style scoped>
.page-wrap {
  display: flex;
  padding: 20px;
}

.content {
  flex: 1;
}

.section-title {
  font-size: 24px;
  margin-bottom: 12px;
}

/* Grid giống ảnh bạn gửi */
.game-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 14px;
}

/* Popup */
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
}

.popup {
  position: fixed;
  right: 40px;
  top: 120px;
  background: #2b2b2b;
  padding: 20px;
  border-radius: 14px;
  width: 300px;
  z-index: 50;
}
</style>
